/**
 * Route → Material Symbols Outlined glyph.
 *
 * Screen System §3 puts a 20px icon beside every fan label, and canon allows
 * exactly one icon set. Centralising the mapping means `MESSAGES` is the same
 * glyph in `.app`, `.men`, `.music` and `.travel` — the four worlds that all
 * carry that route — instead of four developers each picking a plausible one.
 *
 * A route with no entry renders its label alone. That is deliberate: a missing
 * glyph should look like a missing glyph, not like a wrong one silently
 * substituted.
 */
export const ROUTE_ICONS: Record<string, string> = {
  // Shared across worlds
  feed: 'whatshot',
  people: 'group',
  places: 'place',
  messages: 'forum',

  // The fixed tail. The door's key stays `passport`; the words on screen are
  // WORLDS (routeLabel in worlds.ts), so the glyph is the worlds globe — the
  // same mark `.brand` already uses for its own `worlds` room.
  passport: 'public',
  hottie: 'auto_awesome',

  // .travel
  destinations: 'explore',
  trips: 'map',
  stays: 'hotel',

  // .tv
  live: 'sensors',
  shows: 'movie',
  library: 'video_library',

  // .music
  catalogue: 'album',
  playlists: 'queue_music',

  // .news
  latest: 'bolt',
  topics: 'tag',
  saved: 'bookmark',

  // .chat
  threads: 'forum',
  requests: 'mark_email_unread',

  // .care
  today: 'wb_twilight',
  history: 'history',
  journey: 'timeline',
  settings: 'tune',

  // .brand
  guidelines: 'menu_book',
  kit: 'widgets',
  worlds: 'public',
};
